import routerOptions0 from "/home/musman1/workspace/IssuesNetshore/Fixsirat-Admin/fixsirat-admin-frontend/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}